import "./SeoAudits.module.css";
import Header from "@/reusable_sections/Header";
import Clarityauditcta from "./sections/Clarityauditcta";
import AuditComponents from "./sections/AuditComponents";
import Faq from "./sections/Faq";
import Heroaudit from "./sections/Heroaudit";
import AuditBenefits from "./sections/AuditBenefits";
import Methodology from "./sections/Methodology";
import Footer from "@/reusable_sections/Footer";
export default function SeoAuditsPage() {
  return <div>
      <Header />
      <Clarityauditcta />
      <AuditComponents />
      <Faq />
      <Heroaudit />
      <AuditBenefits />
      <Methodology />
      <Footer />
    </div>;
}